import { useState, useEffect } from 'react';
import { Button, TextField, Typography, Grid, Modal, Fade, Box, Autocomplete } from '@mui/material'// component
import { useForm } from "../useForm";
import { getUserType } from '../../config/services/usertype';
import { makeStyles } from '@mui/styles'

const initialFValues = {
    _id: 0,
    roleName: ''
}

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'auto'
    },
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #fff',
        boxShadow: '0px 0px 4px #0000001A',
        minWidth: '300px',
        borderRadius: '4px',
        textAlign: 'center',
    },
    modalTitle: {
        fontSize: '18px',
    },
    outlineButton: {
        color: '#85888A',
        fontSize: '14px',
        border: '1px solid #DEDEDE',
        borderRadius: '4px',
        fontWeight: 'normal',
        marginRight: '10px',
        padding: '0.5rem 1.5rem'
    },
    containedButton: {
        color: '#fff',
        fontSize: '14px',
        border: '1px solid #F45E29',
        borderRadius: '4px',
        fontWeight: 'normal',
        padding: '0.5rem 1.5rem'
    }
}));

export default function UserPopup(props) {
    const { addOrEdit, recordForEdit, openPopup, handleCloseEditPopup, handleOnChange, rolesList, handleSelectRole } = props
    const [userTypeList, setUserTypeList] = useState([]);
    const [userTypeAccess, setUserTypeAccess] = useState(null);

    const classes = useStyles();

    const fetchUserTypeList = () => {
        let params = { pageNo: 0 }
        getUserType(params).then((res) => {
            setUserTypeList([...res?.result]);
        });
    }

    useEffect(() => {
        fetchUserTypeList();
    }, []);

    const setUserTypeValueInital = (value) => {
        if (value && value[0]) {
            setUserTypeAccess(value[0]._id)
        }
    }

    useEffect(() => {
        setUserTypeValueInital(recordForEdit?.userType);
    }, [recordForEdit])

    const validate = (fieldValues = values) => {
        let temp = { ...errors }
        if ('roleName' in fieldValues) {
            temp.roleName = fieldValues.roleName ? "" : "This field is required."
        }

        setErrors({
            ...temp
        })

        if (fieldValues === values)
            return Object.values(temp).every(x => x === "")
    }

    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        resetForm
    } = useForm(initialFValues, true, validate);

    const handleSubmit = e => {
        e.preventDefault()
        if (validate()) {
            values.userType = [userTypeAccess];
            addOrEdit(values, resetForm);
        }
    }

    useEffect(() => {
        if (recordForEdit != null)
            setValues({
                ...recordForEdit
            })
    }, [recordForEdit, setValues])


    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={openPopup}
            closeAfterTransition
        >
            <Fade in={openPopup}>
                <Box className={classes.modalPaper + " modal-box modal-md"} id="transition-modal-title">
                    <Box className="modal-header p-1" >
                        <Typography variant="subtitle1" className={classes.modalTitle + " modal-header-title"} >User Details</Typography>
                    </Box>
                    <Box className="modal-content text-left">
                        <Grid container mb={2} spacing={2} >
                            <Grid item xs={12} sm={6} md={6} lg={6} >
                                <Typography className="text-small label" variant="subtitle2">First Name *</Typography>
                                <TextField fullWidth value={recordForEdit?.firstName} className="report_form_ui_input" name="firstName" onChange={handleOnChange} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} >
                                <Typography className="text-small label" variant="subtitle2">Last Name *</Typography>
                                <TextField fullWidth value={recordForEdit?.lastName} className="report_form_ui_input" name="lastName" onChange={handleOnChange} />
                            </Grid>
                        </Grid>

                        <Grid container mb={2} spacing={2} >
                            <Grid item xs={12} sm={6} md={6} lg={6} >
                                <Typography className="text-small label" variant="subtitle2" mt={1}>Email</Typography>
                                <TextField fullWidth value={recordForEdit?.email} className="report_form_ui_input" name="email" onChange={handleOnChange} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} >
                                <Typography className="text-small label" variant="subtitle2 mt={1}">Password *</Typography>
                                <TextField fullWidth className="report_form_ui_input" autoComplete="new-password" type='password' name="password" onChange={handleOnChange} /> </Grid>
                        </Grid>

                        <Grid container mb={2} spacing={2} >
                            <Grid item xs={12} sm={6} md={6} lg={6} >
                                <Typography className="text-small label" variant="subtitle2" mt={1}>Employee Code *</Typography>
                                <TextField fullWidth value={recordForEdit?.s_uuid} className="report_form_ui_input" name="s_uuid" onChange={handleOnChange} />
                            </Grid>
                            <Grid item xs={12} sm={6} md={6} lg={6} >
                                <Typography className="text-small label" variant="subtitle2" mt={1}>Role *</Typography>
                                <Autocomplete
                                    className="cm_rprt_setting_content report_form_ui_input_select pl-0 report_search_visual_dataset"
                                    size='small'
                                    disablePortal
                                    disableClearable
                                    getOptionLabel={option => option.roleName}
                                    options={rolesList}
                                    renderInput={(params) => <TextField name='role' {...params} />}
                                    onChange={handleSelectRole}
                                    value={recordForEdit?.roleDetails}
                                />
                            </Grid>
                        </Grid>

                        <Grid container mb={2} spacing={2} >
                            <Grid item xs={12} sm={12} md={12} lg={12} >
                                <Typography className="text-small label" variant="subtitle2" mt={1}>School Codes (Optional)</Typography>
                                <Typography className='helpr_txt'>School codes must be comma separated for data level security</Typography>
                                <TextField fullWidth value={recordForEdit?.schoolCodes} className="report_form_ui_input" name="schoolCodes" onChange={handleOnChange} />
                            </Grid>
                        </Grid>

                        <Box className="modal-footer text-right" >
                            <Button onClick={handleCloseEditPopup} className={classes.outlineButton + " report_form_ui_btn cancel mr-2"} color="primary" variant="outlined" > Cancel </Button>
                            <Button onClick={addOrEdit} color="primary" autoFocus className={classes.containedButton + " report_form_ui_btn submit"} variant="contained"> Submit </Button>
                        </Box>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    )
}